<template>
<div>
   <cur-location :location="location"/>
  <div class="article-detail">
    <div class="container">
        <div class="box-title">权威机构查询</div>
        <div class="text">
          <el-row :gutter="20" v-for="n in rows_count" :key="n">
            <el-col :span="6" class="adiv">
              <a :href="jg_links[n-1].url">
                <span>{{jg_links[n-1].name}}</span>
              </a>
            </el-col>
            <el-col :span="6" v-if="jg_links[n]" class="adiv">
              <a :href="jg_links[n].url" >
                <span>{{jg_links[n].name}}</span>
              </a>
            </el-col>
            <el-col :span="6" v-if="jg_links[n+1]" class="adiv">
              <a :href="jg_links[n+1].url">
                <span>{{jg_links[n+1].name}}</span>
              </a>
            </el-col>
            <el-col :span="6" v-if="jg_links[n+2]" class="adiv">
              <a :href="jg_links[n+2].url">
                <span>{{jg_links[n+2].name}}</span>
              </a>
            </el-col>
          </el-row>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import CurLocation from "../components/PublicComs/CurLocation.vue";
export default {
  props: {
    plates: Array,
  },
  components: { CurLocation },
  data() {
    return {
      global,
      intTotal: 0,
      intCurrent: 1,
      articles: [],
      location: {
        name: "权威机构查询",
        link: "",
        type: "views",
      },
      plateId: "",
      isPhone: global.isPhone(),
      navs:[],
      jg_links:[],
      rows_count: 0
    };
  },
created() {
      this.$axios
      .get("/api/links?sort=-createdAt&type=权威机构&limit=100")
      .then((res) => {
        if (res.data) {
          this.jg_links=res.data.data;
          this.rows_count = Math.ceil(this.jg_links.length/4);
        }
      })
    },
  methods: {
    
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getaddtime(article) {
      if (!article.addtime) {
        let addtime = article.createdAt;
        let date = new Date(addtime);
        return `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(
          -2
        )}-${("00" + date.getDate()).slice(-2)} ${(
          "00" + date.getHours()
        ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
          "00" + date.getSeconds()
        ).slice(-2)}`;
      } else {
        return article.addtime;
      }
    },
  },
  beforeUpdate() {
    this.toTop();
  },
  beforeDestroy() {
    this.toTop();
  },
  computed: {},
  mounted() {
    
  },

  watch: {},
};
</script>
<style scoped>
.adiv{
  background-repeat: no-repeat;
    background-position: 5px center;
    background-image: url(/static/img/dian.png);
    padding: 15px;


}
.adiv a{
  font-size: 18px;
  padding-left: 10px;
}
</style>
